import { useTranslation } from 'react-i18next'

type TimelineEmptyStateProps = {
  followupName: string
}

const TimelineEmptyState = ({ followupName }: TimelineEmptyStateProps) => {
  const { t } = useTranslation()

  return (
    <div className="c-flex c-flex-col c-items-center c-justify-center c-w-full c-gap-4 c-py-16 c-bg-[#f0f5ff] c-rounded-xl">
      <img src="/assets/img/empty-followup-timeline.svg" alt="" className="c-w-44" />
      <p className="c-text-center c-m-0 c-text-[#002C8C]">
        {t('components.patient.patient-file.body.followup-details.timeline-empty-state', { followupName })}
      </p>
    </div>
  )
}

export default TimelineEmptyState
